import {h} from 'vue'
import {RouteRecordRaw, RouterView} from 'vue-router'
import {ClientRouteParamType} from '@toolify/client/src/setup/router/enum/ClientRouteParamType'
import {LocaleType} from '@toolify/server/src/services/UserSettingsService/strategies/LocaleUserSettingStrategy/enum/LocaleType'

export function wrapRoutesWithOptionalLocalePrefix(routes: RouteRecordRaw[]): RouteRecordRaw[] {
  return [{
    path: `/:${ClientRouteParamType.Locale}(${Object.values(LocaleType).join('|')})?`,
    component: {render: () => h(RouterView)},
    children: routes.map(route => ({
      ...route,
      path: route.path.replace(/^\//, ''),
    })),
  }]
}
